import React from 'react';

import classNames from 'classnames';

import styles from './Chevron.module.css';

export enum ChevronColor {
  accent = 'var(--grey-300)',
  accentLight = 'var(--grey-100)',
  accentLinkish = 'var(--chevron-accent-linkish-color)',
  accentWhite = 'var(--white)',
  primary = 'var(--chevron-color)',
  primaryHeader = 'var(--header-chevron-color)',
  primaryHeaderPurple = 'var(--midnight-purple)',
  secondaryHeader = 'var(--secondary-header-chevron)',//Business page V3
  secondaryHeaderActive = 'var(--secondary-header-chevron-active)',//Business page V3
}

export type ChevronVariant = 'up' | 'down' | 'right' | 'left';

export type Props = {
  background?: string;
  className?: string;
  fill?: ChevronColor | string;
  height?: number;
  onClick?(): void;
  transitionDuration?: number;
  variant?: ChevronVariant;
  width?: number;
};

export const Chevron = React.memo((props: Props) => {
  const {
    fill = ChevronColor.primary,
    background,
    variant = 'down',
    width = 24,
    height = 24,
    className,
    onClick,
    transitionDuration = 0.5,
  } = props;

  const style = {
    minWidth: width,
    minHeight: height,
    background,
    transition: `transform ${transitionDuration}s ease`,
  };

  return (
    <svg
      width={width}
      height={height}
      className={classNames(styles[variant], className)}
      onClick={onClick}
      viewBox='0 0 24 24'
      fill='none'
      style={style}
    >
      <path
        d='M17.2862 10L11.7291 15.6569L6.17188 10'
        stroke={fill}
        strokeWidth='3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
});
